module.exports = __webpack_public_path__ + "static/topAikido-4d83d065b7f7a55d8ea8e3f49008e291.webp";